export enum RewardStatus {
  Active = 1,
  Redeemed = 2,
  Locked = 3
}

export enum OfferStatus {
  Active = 4,
  Saved = 5
}

export enum ItemType {
  Reward = 1,
  Offer = 2
}

export interface RewardOfferItemI {
  id: number,
  leftImageUrl: string,
  topTitle: string,
  bottomTitle: string,
  callToActionText: string,
  status: RewardStatus | OfferStatus,
  expirationDate?: Date,
  detail: string
}